export const setKeysInLocalStorage = (keyValueMap: Record<string, string>) => {
  if (typeof window === 'undefined') return {}

  Object.entries(keyValueMap).forEach(([key, value]) => {
    localStorage.setItem(key, value)
  })
}

export const getKeysFromLocalStorage = (keys: Array<string>) => {
  if (typeof window === 'undefined') return {}

  const keyValueMap: Record<string, string> = {}

  keys.forEach(key => {
    const value = localStorage.getItem(key)
    if (value) {
      keyValueMap[key] = value
    }
  })

  return keyValueMap
}
